import { useState } from "react";

export function useJournalSectionPagination(initialLimit = 10) {
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(initialLimit);
  const [jumpPage, setJumpPage] = useState("");

  const onLimitChange = (newLimit: number) => {
    setLimit(newLimit);
    setPage(1);
  };

  const onJump = (total: number) => {
    const n = Number(jumpPage);
    if (!Number.isFinite(n) || !n) return;
    const pageCount = Math.max(1, Math.ceil(total / limit));
    setPage(Math.min(Math.max(1, n), pageCount));
    setJumpPage("");
  };

  return { page, setPage, limit, onLimitChange, jumpPage, setJumpPage, onJump };
}

export type JournalSectionPaginationState = ReturnType<
  typeof useJournalSectionPagination
>;
